import { BOSS_SIZE } from '../../constants';
import { OgreBossSprite } from '../../assets/OgreBossSprite';

/**
 * Renders the regular boss: directional ogre-boss sprite with an HP bar above it.
 * Props: enemy, playerCx, playerCy
 */
export function BossEntity({ enemy, playerCx = 0, playerCy = 0 }) {
  const hpPct = Math.max(0, (enemy.hp / enemy.maxHp) * 100);
  const ecx   = enemy.x + BOSS_SIZE / 2;
  const ecy   = enemy.y + BOSS_SIZE / 2;
  const dx    = playerCx - ecx;
  const dy    = playerCy - ecy;

  return (
    <div style={{ position: 'absolute', transform: `translate3d(${enemy.x}px,${enemy.y}px,0)` }}>
      {/* HP bar floats above the boss */}
      <div className="boss-hp-track">
        <div className="boss-hp-fill" style={{ width: `${hpPct}%` }} />
      </div>

      {/* Boss body — directional ogre-boss sprite */}
      <div
        className="boss-body"
        style={{ width: BOSS_SIZE, height: BOSS_SIZE, boxShadow: '0 0 14px 4px rgba(255,80,0,0.80)' }}
      >
        <OgreBossSprite dx={dx} dy={dy} size={BOSS_SIZE} />
      </div>
    </div>
  );
}
